export const hasOverlap = <T>(a: readonly T[], b: readonly T[]): boolean => a.filter((x) => b.includes(x)).length > 0;
